import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

/* View Models */
import { PasswordResetViewModel } from '../viewmodels/reset-password-viewmodel';

/* Services */
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-password-reset-cmp',
  templateUrl: './password-reset.component.html',
})
export class PasswordResetComponent {
  @ViewChild('tooltip') tooltip: NgbTooltip;
  passwordRegex = '';
  passwordValidationError = '';
  resetPasswordVM: PasswordResetViewModel;
  passwordResetSuccessMessage = '';
  showPassword = false;
  resetPasswordErrorMessage = '';

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log(params);
      if (params['token'] !== undefined) {
        this.resetPasswordVM = new PasswordResetViewModel();
        this.resetPasswordVM.token = params['token'];
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  onPasswordChange() {
    if (this.resetPasswordVM.password !== this.resetPasswordVM.confirm) {
      this.passwordValidationError = 'Passwords do not match';
    } else {
      console.log('Password change');
      console.log('Token: ' + this.resetPasswordVM.token);
      console.log('Username: ' + this.resetPasswordVM.username);

      /* check if the password reset request is valid */
      this.authenticationService.resetPassword(this.resetPasswordVM).subscribe((resp) => {
        if (resp.result) {
          this.passwordValidationError = '';
          this.passwordResetSuccessMessage = resp.message;
        } else {
          this.passwordValidationError = resp.message;
          this.passwordResetSuccessMessage = '';
        }
      });
    }
  }
}
